import { ACCEPT_STATUS_CODE, NOT_FOUND_STATUS_CODE } from 'layouts/Main/components/ExcelExportDialogV2/constants';

export const ON_SUCCESS_MESSAGE = 'Valuations of portfolio companies are ready for download';
export const ON_SUCCESS_NOTIFICATION_MESSAGE = 'Valuations of portfolio companies were downloaded successfully';
export const DEFAULT_ERROR_MESSAGE =
  'An error occurred while checking the reports of valuations of portfolio companies';
export const MAX_ATTEMPTS_MESSAGE =
  'Looks like the reports of valuations of portfolio companies are taking longer than expected. Please contact support if needed';
export const INFO_MESSAGE =
  'The reports of valuations of portfolio companies are taking longer than expected due to server timeouts';
export const KEEP_POLLING_STATUS_CODES = [ACCEPT_STATUS_CODE, NOT_FOUND_STATUS_CODE];
